  document.addEventListener("DOMContentLoaded", function () {
    const botones = document.querySelectorAll(".navlink-corporativo");
    const secciones = document.querySelectorAll(".caja-corporativo section");

    // Mostrar la primera sección por defecto si no hay hash
    if (!window.location.hash && secciones[0]) {
      secciones.forEach(s => s.classList.remove("activo"));
      secciones[0].classList.add("activo");
      botones[0]?.classList.add("activo");
    }

    botones.forEach(boton => {
      boton.addEventListener("click", function (e) {
        e.preventDefault();

        const id = this.dataset.id;

        // Oculta todas
        secciones.forEach(s => s.classList.remove("activo"));

        // Muestra la correspondiente
        const seleccionada = document.querySelector(`#${id}`);
        if (seleccionada) {
          seleccionada.classList.add("activo");
        }

        // Quitar clase 'activo' de todos los botones
        botones.forEach(b => b.classList.remove("activo"));
        this.classList.add("activo");

        // ⚠️ Cambiar el hash sin provocar scroll
        history.pushState(null, '', `#${id}`);
      });
    });

    // Activar la pestaña según el hash al cargar la página o si cambia manualmente
    function activarDesdeHash() {
      const hash = window.location.hash.replace('#', '');
      const tabLink = document.querySelector(`.navlink-corporativo[data-id="${hash}"]`);
      const tabContent = document.getElementById(hash);

      if (tabLink && tabContent) {
        // Desactiva todas
        botones.forEach(link => link.classList.remove('activo'));
        secciones.forEach(content => content.classList.remove('activo'));

        // Activa las correspondientes
        tabLink.classList.add('activo');
        tabContent.classList.add('activo');
      }
    }

    // Ejecutar al entrar por URL con hash
    if (window.location.hash) {
      setTimeout(() => {
        activarDesdeHash();
      }, 10); // deja tiempo al DOM
    }

    // También al cambiar el hash manualmente
    window.addEventListener('hashchange', activarDesdeHash);
  });
